module.exports = __webpack_public_path__ + "media/nye-b.8c630b28.mp4";